<template>
  <div>
    <div class="row u-align-items-center u-justify-content-center u-margin-0">
      <div
        class="es-xs-12 es-sm-12 es-md-12 es-lg-12"
        :class="{ 'es-xl-8': !modal, 'es-xl-12': modal }"
      >
        <form @submit="(e) => SAVE_PROJECT(e, $refs.save.SET_LOADING)">
          <div class="row u-margin-0">
            <div class="es-xs-12 es-sm-6">
              <BaseInput
                block
                :label="$t('project.model')"
                size="sm"
                :placeholder="$t('project.modelPlaceholder')"
                v-model="form.model"
                :icon="'black-board'"
                :mandotary="validActivated"
              ></BaseInput>
            </div>
            <div class="es-xs-12 es-sm-6">
              <SelectBox
                optionField="key"
                @open="
                  (search, loading) =>
                    getOptions(search, loading, {
                      key: 'Refrigerants',
                      query: {},
                    })
                "
                :options="
                  getBatteryFeatureByFeatureType(
                    'Evaporator',
                    'Refrigerants' + JSON.stringify({})
                  )
                "
                :validActivated="validActivated"
                :label="$t('refrigerants')"
                v-model="form.refrigerantId"
              ></SelectBox>
            </div>
            <div class="es-xs-12 es-sm-6">
              <BatterySearch
                label="Evaporator"
                type="Evaporator"
                @option:selected="SET_BATTERY_FEATUERS($event, 'Evaporator')"
                :validActivated="validActivated"
                :searchable="true"
                v-model="form.evaporatorBatteryId"
              ></BatterySearch>
            </div>
            <div class="es-xs-12 es-sm-6">
              <BaseInput
                block
                :label="$t('project.evaporatorAirFlow')"
                size="sm"
                :placeholder="
                  $t('common.enterPlaceholder', {
                    label: $t('project.evaporatorAirFlow'),
                  })
                "
                v-model="form.evaporatorAirflow"
                :icon="'paper'"
                :mandotary="validActivated"
              ></BaseInput>
            </div>
            <div class="es-xs-12 es-sm-4">
              <BatterySearch
                :label="$t('cyclesForm.condenser')"
                type="Condenser"
                @option:selected="SET_BATTERY_FEATUERS($event, 'Condenser')"
                :validActivated="validActivated"
                :searchable="true"
                v-model="form.condenserBatteryId"
              ></BatterySearch>
            </div>
            <div class="es-xs-12 es-sm-4">
              <BaseInput
                block
                :label="$t('project.condenserAirFlow')"
                size="sm"
                :placeholder="
                  $t('common.enterPlaceholder', {
                    label: $t('project.condenserAirFlow'),
                  })
                "
                v-model="form.condenserAirflow"
                :icon="'paper'"
                :mandotary="validActivated"
              ></BaseInput>
            </div>
            <div class="es-xs-12 es-sm-4">
              <SelectBox
                optionField="name"
                :options="[
                  { value: 1, name: 1 },
                  { value: 2, name: 2 },
                ]"
                :validActivated="validActivated"
                :label="$t('project.condenserCount')"
                v-model="form.condenserCount"
              ></SelectBox>
            </div>
            <div class="es-xs-12 es-sm-6">
              <SelectBox
                optionField="name"
                @open="getCompressorBrands"
                @search="getCompressorBrands"
                @option:selected="GET_COMPRESSOR_BRAND_REFRIGERANTS"
                :options="compressorBrands"
                :validActivated="validActivated"
                :label="$t('project.compressorBrands')"
                v-model="form.compressorBrandId"
              ></SelectBox>
            </div>
            <div class="es-xs-12 es-sm-6">
              <SelectBox
                optionField="name"
                @open="GET_COMPRESSOR_BRAND_REFRIGERANTS"
                @search="GET_COMPRESSOR_BRAND_REFRIGERANTS"
                :disabled="form.compressorBrandId === null"
                @option:selected="GET_COMPRESSOR_BRAND_REFRIGERANTS"
                :options="compressorBrandRefrigerants"
                :validActivated="validActivated"
                :label="$t('project.compressorBrandRefrigerants')"
                v-model="form.brandRefrigerantId"
              ></SelectBox>
            </div>
            <div class="es-xs-12 es-sm-6">
              <SelectBox
                :searchable="true"
                optionField="name"
                @open="GET_COMPRESSOR_BRAND_REFRIGERANTS_MODELS"
                @search="GET_COMPRESSOR_BRAND_REFRIGERANTS_MODELS"
                :disabled="form.brandRefrigerantId === null"
                @option:selected="GET_COMPRESSOR_BRAND_REFRIGERANTS_MODELS"
                :options="compressorRefrigerantModels"
                :validActivated="validActivated"
                :label="$t('project.compressorRefrigerantModels')"
                v-model="form.refrigerantModelId"
              ></SelectBox>
            </div>
            <div class="es-xs-12 es-sm-6">
              <SelectBox
                optionField="name"
                :options="[
                  { value: 1, name: 1 },
                  { value: 2, name: 2 },
                ]"
                :disabled="form.refrigerantModelId === null"
                :validActivated="validActivated"
                :label="$t('project.compressorCount')"
                v-model="form.compressorCount"
              ></SelectBox>
            </div>
            <div class="es-xs-12 es-sm-6">
              <BaseInput
                block
                :label="$t('project.superheat')"
                size="sm"
                :placeholder="
                  $t('common.enterPlaceholder', {
                    label: $t('project.superheat'),
                  })
                "
                v-model="form.superheat"
                :icon="'paper'"
                :mandotary="validActivated"
              ></BaseInput>
            </div>
            <div class="es-xs-12 es-sm-6">
              <BaseInput
                block
                :label="$t('project.subcooling')"
                size="sm"
                :placeholder="
                  $t('common.enterPlaceholder', {
                    label: $t('project.subcooling'),
                  })
                "
                v-model="form.subcooling"
                :icon="'paper'"
                :mandotary="validActivated"
              ></BaseInput>
            </div>
          </div>
          <div
            class="row u-margin-top u-margin-0 u-align-items-center u-justify-content-center"
          >
            <div class="es-xs-12 es-sm-12">
              <Button
                ref="save"
                @submit="SAVE_PROJECT"
                type="submit"
                block
                variant="primary"
              >
                <i class="icofont-save"></i> {{ $t("project.add") }}
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import BaseInput from "../Base/Inputs/BaseInput.vue";
import SelectBox from "../Base/Inputs/SelectBox.vue";
import Button from "../Base/Button.vue";
import { mapGetters } from "vuex";
import Requests from "@/services/Requests";
import BatterySearch from "@/components/Searches/BatterySearch.vue";
export default {
  components: {
    SelectBox,
    Button,
    BatterySearch,
    BaseInput,
  },
  props: {
    project: {
      default: null,
    },
    edit: {
      default: false,
      type: Boolean,
    },
    modal: {
      default: false,
      type: Boolean,
    },
    mainProject: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      isLoading: true,
      validActivated: false,
      form: {
        model: "",
        superheat: null,
        subcooling: null,
        evaporatorAirflow: null,
        condenserAirflow: null,
        refrigerantId: null,
        compressorBrandId: null,
        brandRefrigerantId: null,
        refrigerantModelId: null,
        compressorCount: null,
        evaporatorBatteryId: null,
        condenserBatteryId: null,
        condenserCount: null,
      },
      evaporators: [],
      condensers: [],
      compressorBrands: [],
      compressorBrandRefrigerants: [],
      compressorRefrigerantModels: [],
    };
  },
  computed: {
    ...mapGetters(["getBatteryFeatureByFeatureType"]),
  },
  methods: {
    SET_BATTERY_FEATUERS(option, type) {
      if (type === "Evaporator") {
        this.form.evaporatorAirflow = option.airflow;
        this.form.superheat = option.superheat;
        this.form.subcooling = option.subcooling;
      } else if (type === "Condenser") {
        this.form.condenserAirflow = option.airflow;
      }
    },
    async INIT_PAGE() {
      this.isLoading = true;
      if (this.edit) {
        this.form = { ...this.project };
      } else if (this.project) {
        this.form = { ...this.project };
      } else if (this.$route.params.projectId) {
        const response = await this.$store.dispatch("getProjectById", {
          id: this.$route.params.projectId,
        });
        if (response.message === "OK") {
          this.form = { ...response.data };
        }
      }
      this.isLoading = false;
    },
    async getOptions(search, loading, option) {
      loading(true);
      await this.$store.dispatch("getBatteryFeatures", {
        ...option,
        batteryType: "Evaporator",
      });
      loading(false);
    },
    async getCompressorBrands(search, loading) {
      loading(true);
      const response = await Requests.CompressorBrands.GetAll({
        query: { search: search },
      });
      this.form.brandRefrigerantId = null;
      this.form.refrigerantModelId = null;
      if (response.message === "OK") {
        this.compressorBrands = response.data.items;
      } else {
        this.compressorBrands = [];
      }
      loading(false);
    },
    async GET_COMPRESSOR_BRAND_REFRIGERANTS(search, loading) {
      const brandId = this.form.compressorBrandId?.id || null;
      if (!brandId) return;
      loading(true);
      this.form.refrigerantModelId = null;
      const response = await Requests.CompressorBrandRefrigerants.GetAll({
        query: {
          brandId: this.form.compressorBrandId.id,
          search: search,
        },
      });
      if (response.message === "OK") {
        this.compressorBrandRefrigerants = response.data.items.filter(
          (item) => item.compressorBrandInfo.id === brandId
        );
      } else {
        this.compressorBrandRefrigerants = [];
      }
      loading(false);
    },
    async GET_COMPRESSOR_BRAND_REFRIGERANTS_MODELS(search, loading) {
      const brandRefrigerantId = this.form.brandRefrigerantId?.id || null;
      if (!brandRefrigerantId) return;
      loading(true);
      const response = await Requests.CompressorRefrigerantModels.GetAll({
        query: {
          brandRefrigerantId: this.form.brandRefrigerantId.id,
          search: search,
        },
      });
      if (response.message === "OK") {
        this.compressorRefrigerantModels = response.data.items.filter(
          (item) =>
            item.compressorBrandRefrigerantInfo.id === brandRefrigerantId
        );
      } else {
        this.compressorRefrigerantModels = [];
      }
      loading(false);
    },
    SAVE_PROJECT(e, loading) {
      e.preventDefault();
      const form = {
        projectNo: this.mainProject?.title || "-",
        model: this.form.model,
        superheat: this.form.superheat,
        subcooling: this.form.subcooling,
        evaporatorAirflow: this.form.evaporatorAirflow,
        condenserAirflow: this.form.condenserAirflow,
        refrigerantId: this.form.refrigerantId.id,
        compressorBrandId: this.form.compressorBrandId.id,
        brandRefrigerantId: this.form.brandRefrigerantId.id,
        refrigerantModelId: this.form.refrigerantModelId.id,
        compressorCount: this.form.compressorCount.value,
        evaporatorBatteryId: this.form.evaporatorBatteryId.id,
        condenserBatteryId: this.form.condenserBatteryId.id,
        condenserCount: this.form.condenserCount.value,
        mainProjectIds: [],
      };
      const valid = this.VALIDATION(form);
      console.log(valid);

      if (!valid) return;
      loading(true);

      if (!this.edit) this.CREATE_PROJECT(loading, form);
      else this.UPDATE_PROJECT(loading, form);
    },
    async CREATE_PROJECT(loading, form) {
      loading(true);
      const response = await this.$store.dispatch("createProject", form);

      if (response.message === "OK") {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("project.success"),
          variant: "success",
          duration: 2500,
        });
        if (this.modal) {
          this.$emit("refresh", {
            id: response.data,
            ...form,
          });
        } else this.$router.push({ name: "projects" });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    async UPDATE_PROJECT(loading, form) {
      loading(true);
      const response = await this.$store.dispatch("updateProject", {
        ...form,
        id: this.project.id,
      });
      if (response.message === "OK") {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("project.success"),
          variant: "success",
          duration: 2500,
        });
        if (this.modal) {
          this.$emit("refresh");
        } else this.$router.push({ name: "projects" });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    VALIDATION(form) {
      this.validActivated = true;
      console.log(form);
      if (Object.values(form).some((item) => !item)) {
        return false;
      }
      return true;
    },
  },
  mounted() {
    this.INIT_PAGE();
  },
};
</script>

<style></style>
